import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import MeterianCredentialsForm from "./MeterianCredentialsForm";
import MeterianConfigListing from "./MeterianConfigListing";

export default function MeterianPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={MeterianCredentialsForm}
      PullConfigListingView={MeterianConfigListing}
    />
  );
}